import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  package: {
    defaultMessage: 'Package',
    description: 'fulfillmentPlanner.package',
    id: 'QdeDCY',
  },
  placeholder: {
    description: 'fulfillmentPlanner.package.dropdown.placeholder',
    defaultMessage: 'Select Package',
    id: 'YW+FQ4',
  },
  actionName: {
    description: 'presets.actionName',
    defaultMessage: 'Apply Preset',
    id: 'X9ttus',
  },
  managePresets: {
    description: 'presets.managePresets',
    defaultMessage: 'Manage Presets',
    id: 'yDQTww',
  },
  unspecifiedService: {
    description: 'requestedShippingService.unspecifiedService',
    defaultMessage: 'Not Specified',
    id: '/pmsCG',
  },
  unmappedServiceDisplayText: {
    description: 'requestedShippingService.unmappedService',
    defaultMessage: 'unmapped',
    id: 'IMRmGa',
  },
  mappedServiceDisplayText: {
    description: 'requestedShippingService.mappedService',
    defaultMessage: 'mapped',
    id: 'potQqs',
  },
  allPackageTypes: {
    description: 'fulfillmentPlanner.package.dropdown.all',
    defaultMessage: 'All Package Types',
    id: 'gt/s5+',
  },
  shippingService: {
    defaultMessage: 'Service',
    description: 'fulfillmentPlanner.shippingService',
    id: 'msWN+9',
  },
  emptyText: {
    description: 'fulfillmentPlanner.shippingService.emptyText',
    defaultMessage: 'Select Service',
    id: '08+bM5',
  },
  emptyShipmentConfigMessage: {
    description: 'fulfillmentPlanner.shipmentConfiguration.emptySectionText',
    defaultMessage: 'A shipment for this order has already been created. Access the shipping label via the "Print Label" button.',
    id: 'UfJ+Mv',
  },
  shipFrom: {
    defaultMessage: 'Ship From',
    description: 'fulfillmentPlanner.shipFrom',
    id: 'eEiRmt',
  },
  insurance: {
    defaultMessage: 'Insurance',
    description: 'fulfillmentPlanner.insurance',
    id: 'UyP8h4',
  },
  confirmation: {
    defaultMessage: 'Confirmation',
    description: 'fulfillmentPlanner.confirmation',
    id: 'usZJWa',
  },
  confirmationNotSupported: {
    defaultMessage: 'Confirmation is not currently supported with Rate Shopper',
    description: 'The confirmation dropdown option is not supported with rate shopper.',
    id: 'DaIHSW',
  },
  defaultSelectServicePlaceholder: {
    defaultMessage: 'Select Service',
    description: 'shippingServiceSelector.defaultSelectService',
    id: 'VLrkbv',
  },
  packageNotSupported: {
    defaultMessage: 'Package is not currently supported with Rate Shopper',
    description: 'The package dropdown option is not supported with Rate Shopper.',
    id: 'RNd26J',
  },
  multiplePackages: {
    description: 'fulfillmentPlannerPackageDropdown.multiplePackages',
    defaultMessage: 'Multi-Package',
    id: 'LRa8Br',
  },
  customAddress: {
    defaultMessage: 'Custom address',
    description: 'Shown in ship-from field when an inactive/v2-API custom address is set on the order',
    id: 'gsQpzx',
  },
  requestedShipFrom: {
    description: 'Displays the requested ship from location for a given marketplace fulfillment plan',
    defaultMessage: "{marketplaceName}'s Location: {shipFromName}",
    id: '4VTdBi',
  },
  recommendedShippingService: {
    description: 'Displays the recommended shipping service for a given marketplace fulfillment plan',
    defaultMessage: "{marketplaceName}'s Service: {recommendedShippingService}",
    id: 'Pnq+fO',
  },
  globaleExplanation: {
    description: 'help text shown for a specific label provider',
    defaultMessage:
      'Enter weight and dimensions so Global-e can return more accurate rate estimates but may not be reflected on the label.',
    id: 'mYhCHe',
  },
  tikTokShipFromText: {
    description: 'Static text shown for Ship From field on TikTok Shipping orders where the warehouse is configured in TikTok',
    defaultMessage: 'Warehouse configured in TikTok',
    id: 'iOo6On',
  },
  multiPackageCount: {
    description: 'Placeholder text that displays the number of packages in the multi-package dropdown',
    defaultMessage: 'Multi Package - ({count}) Packages',
    id: 'MEolMh',
  },
  managePackagesLink: {
    description: 'Link text to manage packages',
    defaultMessage: 'Manage',
    id: 'R9/gZa',
  },
  noInsuranceOptionSelected: {
    defaultMessage: 'Select your coverage option',
    description: 'shown when users have not selected an insurance preference as part of their FTU onboarding',
    id: 'IuhtUB',
  },
  noPackagesAvailable: {
    description: 'Message shown when no packages are available',
    defaultMessage: 'No packages available',
    id: 'DvTdIn',
  },
});
